import React, {useEffect, useRef} from 'react';
import Quagga from '@ericblade/quagga2';

const Scanner = ({deviceId, onDetect}) => {
	const cameraRef = useRef(null);
	const canvasRef = useRef(null);
	
	useEffect(() => {
		return () => {
			Quagga.stop();
		};
	}, [])
	
	useEffect(() => {
		const quaggaConfig = {
			inputStream: {
				name: "Live",
				type: "LiveStream",
				target: cameraRef.current,
				constraints: {
					width: {min: 640, max: 1270},
					height: {min: 480, max: 720},
					facingMode: "environment", // Use the rear camera
					aspectRatio: {min: 1, max: 2},
					deviceId: {exact: deviceId}
				},
				area: {
					top: "0%",
					right: "0%",
					left: "0%",
					bottom: "0%"
				},
				singleChannel: false
			},
			decoder: {
				readers: ["upc_reader"], // 'ean_reader'
				multiple: false,
			},
			locator: {
				patchSize: "large", // x-small, small, medium, large, x-large
				halfSample: true, // Use half-sampling for faster processing
			},
			frequency: 1000,
			numOfWorkers: 2,
			locate: true
		};
		
		Quagga.init(quaggaConfig, async (err) => {
			Quagga.onProcessed(handleProcessed);
			
			if (err) {
				console.error(err);
				return;
			}
			Quagga.start();
		});
		
		Quagga.onDetected((result) => {
			handleOutput(result)
		});
		
		// Cleanup function to stop Quagga when the component unmounts
		return () => {
			Quagga.stop();
		};
	}, [deviceId]);
	
	
	const handleProcessed = (result) => {
		//https://github.com/ericblade/quagga2-react-example/blob/master/src/Scanner.js
		const drawingCtx = Quagga.canvas.ctx.overlay;
		const drawingCanvas = Quagga.canvas.dom.overlay;
		drawingCtx.font = "24px Arial";
		drawingCtx.fillStyle = 'green';
		
		if (result) {
			if (result.boxes) {
				drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute('width')), parseInt(drawingCanvas.getAttribute('height')));
				result.boxes.filter((box) => box !== result.box).forEach((box) => {
					Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: 'purple', lineWidth: 2});
				});
			}
			if (result.box) {
				Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: 'blue', lineWidth: 2});
			}
			if (result.codeResult && result.codeResult.code) {
				drawingCtx.font = "24px Arial";
				drawingCtx.fillText(result.codeResult.code, 10, 20);
			}
		}
	};
	
	const retryDecoding = () => {
		if (!canvasRef.current || !cameraRef.current) return;
		
		const video = cameraRef.current.querySelector("video");
		const canvas = canvasRef.current;
		const context = canvas.getContext("2d");
		
		// Capture the current video frame
		context.drawImage(video, 0, 0, canvas.width, canvas.height);
		const imageData = canvas.toDataURL("image/png");
		Quagga.decodeSingle({
				decoder: {readers: ["upc_reader", "ean_reader"]},
				locate: true,
				src: imageData,
			},
			(result) => {
				if (result && result.codeResult) {
					sendBarcodeToParent(result)
					Quagga.stop(); // Stop Quagga after successful decoding
				}
			}
		);
	};
	
	const handleOutput = (res) => {
		sendBarcodeToParent(res)
	}
	
	const sendBarcodeToParent = (res) => {
		if (res.codeResult.code?.length === 12)
			onDetect(res.codeResult.code)
		else {
			let res2 = Number(res.codeResult.code)?.toString()?.padStart(12, '0')
			console.log(`barcode size is not matched: ${res.codeResult.code}, run it again with: `, res2)
			res = {...res, codeResult: {...res.codeResult, code: res2}}
			handleOutput(res)
		}
	}
	
	
	return <div className={'Scanner_camera_container'}>
		<div ref={cameraRef} className={'Scanner_camera'}>
			<canvas
				className="drawingBuffer"
				style={{
					position: "absolute",
					top: 0,
					left: 0,
					width: "100%",
					height: "100%",
				}}
			/>
			<canvas ref={canvasRef} width={640} height={480} style={{display: "none"}}/>
		</div>
	</div>
};

export default Scanner;





// Nazemi codes on lab report scanner: https://172.24.128.6/
// <!--<script type="text/javascript">
//         //var config = {
//         //    fps: 10,
//         //    qrbox: 340,
//         //    rememberLastUsedCamera: true,
//         //    // Only support camera scan type.
//         //    // supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA]
//         //};
//         var html5QrcodeScanner = new Html5QrcodeScanner(
//            //   "reader", { fps: 200, qrbox: 300 });
//            // "reader", { fps: 200, qrbox: 340 });
//            // "reader", { fps: 10, qrbox: 250 });
//             "reader", {  qrbox: 300 });
//            // "reader");
//         //
//         function onScanSuccess(qrCodeMessage) {
//
//             html5QrcodeScanner.clear()
//           ReportResultHis.SerahPatient(1, qrCodeMessage)
//         }
//         function onScanError(errorMessage) {
//            // html5QrcodeScanner.clear()
//            // alert('خطا در اسکن ');
//         }
//
//         function startBarcodePicker() {
//
//             $("#grid1").css('display', 'none')
//             $("#grid2").css('display', 'none')
//             $("#gridhistory").css('display', 'none')
//           //  $("#reader").css('display', 'block')
//             $("#LbFamilly").text("")
//             $("#LbGender").text("")
//             $("#LbAge").text("")
//           html5QrcodeScanner.render(onScanSuccess, onScanError);
//
//         }
//
//     </script>-->